export default {
  'imm5669.familyMemberTableTitle': '家庭成員',
  'imm5669.familyMemberTableFullName': '姓名',
  'imm5669.familyMemberTableStatus': '狀態',
  'imm5669.familyMemberTableStatus.missingInformation': '缺少信息',
  'imm5669.familyMemberTableStatus.complete': '完成',

  'imm5669.steps.sectionA': '個人信息',
  'imm5669.steps.sectionB': '問卷',
  'imm5669.steps.sectionC': '教育',
  'imm5669.steps.sectionD': '個人歷史',
  'imm5669.steps.sectionE': '組織會員和協會',
  'imm5669.steps.sectionF': '政府職位',
  'imm5669.steps.sectionG': '軍事和準軍事服務',
  'imm5669.steps.sectionH': '地址',

  'imm5669.title.personal': 'A部分：個人信息',
  'imm5669.personal.fullName': '姓名',
  'imm5669.personal.dob': '出生日期（YYYY/MM/DD）',
  'imm5669.personal.deceasedDate': '死亡日期（如已故）（YYYY/MM/DD）',
  'imm5669.personal.cityOfBirth': '出生城市',
  'imm5669.personal.countryOfBirth': '出生國家或地區',

  'imm5669.personal.father.title': '父親信息',
  'imm5669.personal.mother.title': '母親信息',

  'imm5669.title.questionnaire': 'B部分：問卷',
  'imm5669.description.questionnaire': '您或您列出的家庭成員是否曾：',
  'imm5669.questionnaire.isConvictedInCanada':
    '1. 是否曾在加拿大被判犯罪或違法行為，且未根據加拿大犯罪記錄法獲得赦免？',
  'imm5669.questionnaire.isConvictedOutsideCanada':
    '2. 是否曾在其他國家或地區被判犯罪或違法行為，或目前被指控、審判中、參與犯罪或違法行為，或涉及任何刑事訴訟？',
  'imm5669.questionnaire.isClaimedRefugeeProtection':
    '3. 是否曾在加拿大或加拿大簽證辦公室、其他國家或地區、或聯合國難民事務高級專員公署（UNHCR）提出過難民保護申請？',
  'imm5669.questionnaire.isRefusedRefugeeOrVisa':
    '4. 是否曾被拒絕難民身份、移民或永久居民簽證（包括魁北克選擇證書[CSQ]或省提名計劃申請）或訪客或臨時居民簽證，加拿大或其他國家或地區？',
  'imm5669.questionnaire.isOrderedToLeaveCountry':
    '5. 是否曾被拒絕入境或被命令離開加拿大或其他國家或地區？',
  'imm5669.questionnaire.isWarCriminal':
    '6. 是否曾參與種族滅絕、戰爭罪或反人類罪行？',
  'imm5669.questionnaire.isCommittedActOfViolence':
    '7. 是否曾使用、計劃或倡導使用武裝鬥爭或暴力以實現政治、宗教或社會目標？',
  'imm5669.questionnaire.isAssociatedWithViolentGroup':
    '8. 是否曾與使用、使用過或倡導使用武裝鬥爭或暴力以實現政治、宗教或社會目標的團體有聯繫？',
  'imm5669.questionnaire.isMemberOfCriminalOrg':
    '9. 是否曾是從事犯罪活動的組織的成員？',
  'imm5669.questionnaire.isDetainedOrJailed': '10. 是否曾被拘留、監禁或入獄？',
  'imm5669.questionnaire.isPhysicalOrMentalDisorder':
    '11. 是否曾患有嚴重疾病或身體或精神障礙？',
  'imm5669.questionnaire.additionalDetails':
    '如果您對任何問題的回答是肯定的，請在下方提供詳細信息（最多679個字符）：',

  'imm5669.title.education': 'C部分：教育',
  'imm5669.education.overallTitle':
    '請提供您在以下各級教育中成功完成的學年數：',
  'imm5669.education.elementarySchoolYears': '小學',
  'imm5669.education.secondarySchoolYears': '中學',
  'imm5669.education.universityAndCollegeYears': '大學/學院',
  'imm5669.education.otherSchoolYears': '職業學校或其他高等教育',

  'imm5669.education.educationHistory.fullDetailsTitle':
    '請提供您所有中學和高等教育（包括大學、學院和學徒培訓）的詳細信息。',
  'imm5669.title.formList.educationHistory': '教育 #',
  'imm5669.education.educationHistory.from': '從（YYYY-MM）',
  'imm5669.education.educationHistory.to': '到（YYYY-MM）',
  'imm5669.education.educationHistory.nameOfInstitution': '機構名稱',
  'imm5669.education.educationHistory.cityAndCountry': '城市和國家/地區',
  'imm5669.education.educationHistory.typeOfDiploma': '頒發的證書或文憑類型',
  'imm5669.education.educationHistory.fieldOfStudy': '學習領域',

  'imm5669.title.personalHistory': 'D部分：個人歷史',
  'imm5669.description.personalHistory':
    '請提供您過去10年的個人歷史，或自您18歲生日以來的個人歷史（如果少於10年）。從最近的信息開始。在“活動”下，寫下您的職業或職位。如果您沒有工作，請提供您在做什麼的信息（例如，失業、學習、旅行、退休、被拘留）。如果您在國籍所在國家或地區之外，請注明您在所在國家或地區的身份。注意：請確保時間上沒有空白。',
  'imm5669.title.formList.personalHistory': '個人歷史 #',
  'imm5669.personalHistory.from': '從（YYYY-MM）',
  'imm5669.personalHistory.to': '到（YYYY-MM）',
  'imm5669.personalHistory.activity':
    '活動（例如，工作 - 公司名稱和職位，失業，教育）',
  'imm5669.personalHistory.cityAndCountry': '城市和國家/地區',
  'imm5669.personalHistory.status':
    '在國家或地區的身份（例如，工作許可，公民，學生許可，訪客許可）',
  'imm5669.personalHistory.nameOfEmployerOrSchool':
    '公司、雇主、學校、設施名稱（如適用）',

  'imm5669.title.memberships': 'E部分：組織會員和協會',
  'imm5669.description.memberships':
    '您支持、成為會員或與哪些組織有聯繫？包括任何政治、社會、青年或學生組織、工會和專業協會。請勿使用縮寫。注明您成為會員的城市和國家或地區。如果您沒有加入任何協會/組織，請在第一個輸入字段中寫“無”。',
  'imm5669.title.formList.memberships': '會員 #',
  'imm5669.memberships.from': '從（YYYY-MM）',
  'imm5669.memberships.to': '到（YYYY-MM）',
  'imm5669.memberships.nameOfOrganization': '組織名稱',
  'imm5669.memberships.typeOfOrganization': '組織類型',
  'imm5669.memberships.activities': '在組織中的活動和/或職位',
  'imm5669.memberships.cityAndCountry': '城市和國家/地區',

  'imm5669.title.governmentPositions': 'F部分：政府職位',
  'imm5669.description.governmentPositions':
    '列出您曾擔任的任何政府職位（如公務員、法官、警察、安保組織員工）。包括您退休前後的職位。請勿使用縮寫。如果您沒有擔任任何政府職位，請在第一個輸入字段中寫“無”。',
  'imm5669.title.formList.governmentPositions': '政府職位 #',
  'imm5669.governmentPositions.from': '從（YYYY-MM）',
  'imm5669.governmentPositions.to': '到（YYYY-MM）',
  'imm5669.governmentPositions.cityAndCountry':
    '國家/地區和管轄級別（國家、地區、市級）',
  'imm5669.governmentPositions.department': '部門/分支',
  'imm5669.governmentPositions.activities': '活動和/或職位',

  'imm5669.title.militaryPositions': 'G部分：軍事和準軍事服務',
  'imm5669.description.militaryPositions':
    '請提供您在所服務國家的武裝部隊中的軍事和準軍事服務的完整詳細信息。如果您沒有進行過軍事和/或準軍事服務，請在第一個輸入字段中寫“無”。注意：請確保時間上沒有空白。',
  'imm5669.title.formList.militaryPositions': '軍事和準軍事服務 #',
  'imm5669.militaryPositions.country': '國家或地區名稱',
  'imm5669.militaryPositions.branchOfService': '服務分支、單位編號和指揮官姓名',
  'imm5669.militaryPositions.from': '從（YYYY-MM）',
  'imm5669.militaryPositions.to': '到（YYYY-MM）',
  'imm5669.militaryPositions.rank': '軍銜',
  'imm5669.militaryPositions.reasonsEndService': '服務結束原因',
  'imm5669.militaryPositions.combatDetails': '任何戰鬥的日期和地點',

  'imm5669.title.addresses': 'H部分：地址',
  'imm5669.description.addresses':
    '列出您在過去10年中居住過的所有地址，或自您18歲生日以來的地址（如果少於10年）。請勿使用郵政信箱地址。',
  'imm5669.title.formList.addresses': '地址 #',
  'imm5669.addresses.from': '從（YYYY-MM）',
  'imm5669.addresses.to': '到（YYYY-MM）',
  'imm5669.addresses.street': '街道和門牌號',
  'imm5669.addresses.city': '城市或城鎮',
  'imm5669.addresses.provinceOrState': '省、州或地區',
  'imm5669.addresses.country': '國家或地區',
  'imm5669.addresses.postalCode': '郵政編碼或郵政區號',
};
